const route = {
    path: '/profile',
    children: [
        {
            path: '',
            components: {
                default:
                    () => import(/* webpackChunkName: "profile" */ '../../components/views/users/profile.vue'),
            }
        },
    ],
}

module.exports = route;